<div class="select-active-principles-panel">
  <div class="active-principles-panel">
    <h2>{{ labelService.getLabel(title) }}</h2>

    <section class="active-principles-list">
      @for (principle of activePrinciplesList; track principle) {
        <div class="checkbox-principle">
          <app-checkbox
            [size]="15"
            [color]="'light-blue-logo'"
            [checked]="principle.selected || false"
            (change)="addRemoveActivePrinciples(principle)"
          ></app-checkbox>
          <span style="margin-right: 2rem">{{ principle.label }}</span>
        </div>
      }
    </section>

    <div class="description">
      <mat-form-field style="width: 100%">
        <mat-label>{{ labelService.getLabel("description") }}</mat-label>
        <input matInput [(ngModel)]="pharmacotherapyDescription" />
      </mat-form-field>
    </div>

    <div class="panel-buttons">
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('close')"
        (click)="toggleActivePrinciplesPanel()"
      ></app-button>
      <app-button
        [color]="'white'"
        [text]="labelService.getLabel('confirm')"
        (click)="confirmAction()"
        [disabled]="isBtnClicked ? 'disabled-gray' : 'not-disabled'"
      ></app-button>
    </div>
  </div>
</div>
